export default __webpack_public_path__ + "static/media/reports.e7a12c1a.png";